import { useCallback, useContext } from 'react'
import { AppContext } from '../../AppContext'
import { useDecodeArrayBuffer } from './useDecodeArrayBuffer'
import toast from 'react-hot-toast'
import { getUrlFilename } from '../../functions/getUrlFilename'

export function useLoadAudioFileFromUrl() {
  const { setAudioBuffer, setFilename } = useContext(AppContext)
  const decodeArrayBuffer = useDecodeArrayBuffer()

  return useCallback(
    (url: string): Promise<void> =>
      fetch(url)
        .catch(() => {
          toast.error('The file cannot be downloaded')
          return Promise.reject()
        })
        .then((response) => response.arrayBuffer())
        .then((arrayBuffer) => {
          const filename = getUrlFilename(url)

          return decodeArrayBuffer(arrayBuffer, filename).then((audioBuffer) => {
            setFilename(filename)
            setAudioBuffer(audioBuffer)
          })
        }),
    [decodeArrayBuffer, setAudioBuffer, setFilename],
  )
}
